module.exports = __webpack_public_path__ + "img/UTDEAD-3.db6c0f07.jpg";